import { configureStore } from '@reduxjs/toolkit'
import authSlice from './slice/authSlice'
import practiceSlice from './slice/practiceSlice'
import woundCareInfoSlice from './slice/woundCareInfoSlice'
import patientSlice from './slice/patient/patientSlice'
import practiceRegistrationSlice from './slice/practice/practiceRegistrationSlice';
import codetableSlice from './slice/codetableSlice';
import productSlice from './slice/product/createProductSlice';
import practiceApproveSlice from './slice/practice/practiceApproveSlice';
import practiceEditSlice from './slice/practice/practiceEditSlice'
import productListSlice from './slice/product/productListSlice'
import practiceLocationSlice from './slice/practice/practiceLocationSlice'
import practiceProvidersSlice from './slice/practice/practiceProvidersSlice'
import practiceProductsSlice from './slice/practice/practiceProductSlice'
import commonSlice from './slice/commonSlice'
import createAgreementSlice from './slice/productAgreement/createAgreementSlice';
import practiceBillerSlice from './slice/practice/practiceBillerSlice'
import practiceExecutiveSlice from './slice/practice/practiceExecutiveSlice'
import userSlice from './slice/userSlice'
import createIVRSlice from './slice/ivr/createIVRSlice'
import ivrDocumentSlice from './slice/ivr/ivrDocumentSlice'
import OrderSlice from './slice/order/OrderSlice'
import agencySlice from './slice/agency/AgencySlice'
import twoFactorSlice from './slice/2FA/twoFactorSlice'
import InvoiceSlice from './slice/invoice/InvoiceSlice'
import PaymentSlice from './slice/payment/paymentSlice'
import woundCodesSlice from './slice/ivr/woundCodeSlice'
import manufacturerNotificationSlice from './slice/manufacturerNotifications/ManufacturerNotificationSlice'
import providerNotificationSlice from './slice/providerNotifications/ProviderNotificationSlice'
import createBusinessAgreementSlice from './slice/baa/createBusinessAgreementSlice'
import useAuditLogSlice  from './slice/auditLog/auditLogSlice'
import manufacturerSlice from './slice/manufacturer/ManufacturerSlice'
import documentSlice from './slice/document/DocumentSlice'
import createNotificationSlice from './slice/inbox/createNotificationSlice'
import ClaimSlice from './slice/claim/ClaimSlice'
import SaleDetailsSlice from './slice/saleDetails/SaleDetailsSlice'
import dashboardSlice from './slice/dashboard/dashboardSlice'
import commissionSlice from './slice/commission/commissionSlice'
import jobSlice from './slice/jobSlice'
import aiAuditSlice from './slice/AI/AiAuditSlice'
import serviceSubscriptionSlice from './slice/serviceSubscriptionSlice' // CS-1706
import exploreMarketSlice from './slice/exploreMarket/exploreMarketSlice'
import prescriptionSlice from './slice/prescription/prescriptionSlice'
import ec2Slice from './slice/ec2/Ec2Slice' // CS-2018
import pharmacyLicenseSlice from './slice/pharmacy/pharmacyLicenseSlice' // CS-2073
import salesGoalSlice from './slice/isr/salesGoalSlice'
import salesConfigSlice from './slice/isr/salesConfigSlice'
import isrSlice from './slice/isr/isrSlice'

export const store = configureStore({
  reducer: {
    authSlice : authSlice,
    practiceSlice : practiceSlice,
    woundCareInfoSlice : woundCareInfoSlice,
    patientSlice : patientSlice,
    practiceRegistrationSlice: practiceRegistrationSlice,
    codetableSlice: codetableSlice,
    productSlice : productSlice,
    productListSlice : productListSlice,
    practiceApproveSlice: practiceApproveSlice,
    practiceEditSlice: practiceEditSlice,
    practiceLocationSlice: practiceLocationSlice,
    practiceProvidersSlice: practiceProvidersSlice,
    practiceProductsSlice: practiceProductsSlice,
    commonSlice: commonSlice,
    createAgreementSlice: createAgreementSlice,
    practiceBillerSlice: practiceBillerSlice,
    practiceExecutiveSlice: practiceExecutiveSlice,
    userSlice: userSlice,
    createIVRSlice: createIVRSlice,
    ivrDocumentSlice: ivrDocumentSlice,
    orderSlice: OrderSlice,
    agencySlice: agencySlice,
    twoFactorSlice: twoFactorSlice,
    invoiceSlice: InvoiceSlice,
    paymentSlice: PaymentSlice,
    woundCodesSlice: woundCodesSlice,
    createBusinessAgreementSlice: createBusinessAgreementSlice,
    manufacturerNotificationSlice: manufacturerNotificationSlice,
    providerNotificationSlice: providerNotificationSlice,
    manufacturerSlice: manufacturerSlice,
    auditLogSlice:useAuditLogSlice,
    documentSlice: documentSlice,
    createNotificationSlice: createNotificationSlice,
    claimSlice: ClaimSlice,
    salesDetailsSlice: SaleDetailsSlice,
    dashboardSlice: dashboardSlice,
    commissionSlice: commissionSlice,
    jobSlice: jobSlice,
    aiAuditSlice: aiAuditSlice, //CS-1595
    serviceSubscription: serviceSubscriptionSlice, // CS-1706,
    exploreMarket:exploreMarketSlice,
    prescriptionSlice: prescriptionSlice,
    ec2Slice: ec2Slice, // CS-2018
    pharmacyLicenseSlice: pharmacyLicenseSlice, // CS-2073
    salesGoalSlice: salesGoalSlice,
    salesConfigSlice: salesConfigSlice,
    isrSlice: isrSlice,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch